import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = {
  class: "scroll-y mh-450px p-4",
  style: {"min-height":"150px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-building-circle-exclamation fa-4x" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Add Venue", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: ""
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ribbon-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-sitemap text-white" })
], -1)
const _hoisted_10 = { class: "d-flex align-items-center flex-grow-1 me-2 me-sm-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-4 d-none d-md-inline" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-secondary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-building fa-2x text-white" })
  ])
], -1)
const _hoisted_12 = { class: "me-2" }
const _hoisted_13 = { class: "text-white fs-4 fw-bolder d-flex flex-column" }
const _hoisted_14 = { class: "fw-light fs-6" }
const _hoisted_15 = { class: "d-flex mt-2 flex-wrap" }
const _hoisted_16 = { class: "d-block d-md-none col" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus text-primary mb-5 fs-2x" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-5 fw-bold mb-2" }, "Add Venue", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_ctx.venues.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "add venues (buildings) with spaces (rooms) that can be used when scheduling calls like rehearsals and performances"
            }, {
              image: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "btn btn-sm btn-primary d-flex flex-column flex-center",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addVenue && _ctx.addVenue(...args)))
                }, _hoisted_6)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.venues, (venue) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 ribbon ribbon-top ribbon-vertical",
                  key: venue.venueId,
                  onClick: ($event: any) => (_ctx.updateVenue(venue))
                }, [
                  (venue.discriminator === 'OrganizationVenue' && !_ctx.isOrganization)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        content: "Inherited from Organization",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, _toDisplayString(venue.name), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(venue.address), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(venue.spaces, (space) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "badge text-white badge-primary me-4 mt-2",
                            key: space.venueSpaceId
                          }, _toDisplayString(space.name), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ], 8, _hoisted_8))
              }), 128)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "d-flex card flex-center bg-light-primary border-primary border border-dashed p-8 mb-6",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addVenue && _ctx.addVenue(...args)))
                }, _hoisted_19)
              ])
            ]))
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ]))
}